export default {
    getExpectedNextStep(state) {
        return state.expectedNextStep;
    },
}
